import React from 'react'

import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles';

import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';

import IViewQueryParams from './IViewQueryParams';

const styles = (theme: Theme) => ({
  responsive16by9: {
    paddingTop: '56.25%',
    position: 'relative' as 'relative',
    display: 'block',
    width: '100%',
    padding: 0,
    overflow: 'hidden' as 'hidden'
  },  
  responsiveVideo: {
    position: 'absolute' as 'relative',
    top: 0,
    bottom: 0,
    left: 0,
    width: '100%',
    height: '100%',
    border: 0
  }
});

interface Props {
  queryParams: IViewQueryParams;
}

interface State {
}

type PropsWithStyles = Props & WithStyles<'responsive16by9' | 'responsiveVideo'>;

class Player extends React.Component<PropsWithStyles> {

  render() {
    const { queryParams, classes } = this.props

    return (  
      <Container maxWidth="md">      
        <Box>     
          <Box className={classes.responsive16by9} my={4} textAlign="center">
            <video className={classes.responsiveVideo} src={`https://d1y5xfvzlo94cr.cloudfront.net/${queryParams.videoId}/${queryParams.videoId}.mp4`} width='100%' height='100%' controls />
          </Box>
        </Box>
      </Container>
    );
  }

  }

  export default withStyles(styles)(Player);